import { MODEL_FORMAT_OUTPUT } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Returns the explicit modelFormatOutput when set, otherwise infers it
 * from the model URL's file extension (.glb, .fbx, .obj, .stl, .usdz).
 *
 * @param {string} [modelFormatOutput] - Explicit format declared on the run
 * @param {string} modelUrl - URL of the generated model file
 * @returns {string|undefined} - One of MODEL_FORMAT_OUTPUT.* or undefined when nothing matches
 */
export const getModelFormatOutput = ({ modelFormatOutput, modelUrl = '' }) => {
  if (modelFormatOutput) {
    return modelFormatOutput
  }

  // Deleted runs keep their preview but serve `fileUrl: null`, so the URL may be
  // null rather than missing.
  if (modelUrl == null) {
    return undefined
  }

  if (modelUrl.endsWith('.glb')) {
    return MODEL_FORMAT_OUTPUT.GLB
  }

  if (modelUrl.endsWith('.fbx')) {
    return MODEL_FORMAT_OUTPUT.FBX
  }

  if (modelUrl.endsWith('.obj')) {
    return MODEL_FORMAT_OUTPUT.OBJ
  }

  if (modelUrl.endsWith('.stl')) {
    return MODEL_FORMAT_OUTPUT.STL
  }

  if (modelUrl.endsWith('.usdz')) {
    return MODEL_FORMAT_OUTPUT.USDZ
  }

  return undefined
}
